import { useState } from 'react';
import { useGarden } from '../../garden/GardenContext';
import type { ActionLogEntry as ActionLogEntryType } from '../../garden/gardenReducer';

interface ActionLogEntryProps {
  elementId: string;
  entry: ActionLogEntryType;
}

function ActionLogEntry({ elementId, entry }: ActionLogEntryProps) {
  const { updateActionEntry, deleteActionEntry } = useGarden();
  const [isEditing, setIsEditing] = useState(false);
  const [date, setDate] = useState(entry.date);
  const [note, setNote] = useState(entry.note);

  function handleSave() {
    updateActionEntry(elementId, entry.id, date, note);
    setIsEditing(false);
  }

  function handleCancel() {
    setDate(entry.date);
    setNote(entry.note);
    setIsEditing(false);
  }

  if (isEditing) {
    return (
      <li className="action-log__entry action-log__entry--editing">
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="action-log__date-input"
        />
        <input
          type="text"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="action-log__note-input"
          placeholder="What did you do?"
        />
        <div className="action-log__entry-buttons">
          <button type="button" onClick={handleSave}>
            Save
          </button>
          <button type="button" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </li>
    );
  }

  return (
    <li className="action-log__entry">
      <span className="action-log__date">{entry.date}</span>
      <span className="action-log__note">{entry.note}</span>
      <div className="action-log__entry-buttons">
        <button type="button" onClick={() => setIsEditing(true)}>
          Edit
        </button>
        <button type="button" onClick={() => deleteActionEntry(elementId, entry.id)}>
          Delete
        </button>
      </div>
    </li>
  );
}

export default ActionLogEntry;
